import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ValidateUsAddressModalComponent } from '../../../../shared/modal/validate-us-address-modal/validate-us-address-modal.component';

@Component({
  selector: 'us-address',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './us-address.component.html',
  styleUrl: './us-address.component.scss'
})
export class UsAddressComponent {
  constructor(private _modalService: NzModalService) {}

  public onValidateAddressClick(): void {
    this._modalService.create({
      nzContent: ValidateUsAddressModalComponent,
      nzWidth: 554,
      nzCentered: true,
      nzWrapClassName: 'modal-wrap'
    });
  }
}
